import * as React from 'react';
import { Col } from 'reactstrap';
import { Svg } from './Svg';

interface IStepIconProps {
  activeFill: string;
  fill: string;
  isActive: boolean;
  opacity: number;
  stepNumber: number;
  src?: string;
}

export const StepIcon: React.SFC<IStepIconProps> = ({
  activeFill,
  fill,
  isActive,
  opacity,
  src,
  stepNumber,
}) => {
  return (
    <Col
      className='d-flex flex-column align-items-center position-relative'
      xs='2'
    >
      <span
        className='step-number text-center text-white mt-1'
        style={{ zIndex: 10 }}
      >
        {stepNumber}
      </span>
      <Svg
        className='position-absolute'
        width={48}
        height={48}
        fill={isActive ? activeFill : fill}
        opacity={opacity}
        src={src ? src : 'step-bulle'}
      />
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/StepIcon.tsx